// import { INavData } from "@coreui/angular";

// Items are grouped under section headers (`title: true`, rendered by CoreUI as a nav title).
// Routes, permissions and badges are unchanged — only the grouping is new. Headers carry no
// permission of their own; DefaultLayoutComponent drops any header left without visible items.
export const navItems = [
  {
    name: "Main",
    title: true,
  },
  {
    name: "Dashboard",
    url: "/dashboard",
    icon: "icon-home",
    class: "icon-red-100",
    permission: "See dashboard",
  },
  {
    name: "Calendar",
    url: "/calendar",
    icon: "icon-calendar",
    class: "icon-red-400",
    permission: "Calendar",
  },
  {
    name: "Operations",
    title: true,
  },
  {
    name: "Work Orders",
    url: "/work-orders",
    icon: "icon-notebook",
    class: "icon-red-200",
    permission: "See work orders",
  },
  {
    name: "Requests",
    url: "/requests",
    icon: "icon-book-open",
    class: "icon-red-300",
    permission: "Requests",
  },
  {
    name: "Estimates",
    url: "/bids",
    icon: "icon-direction",
    class: "icon-red-600",
    permission: "See bids",
  },
  {
    name: "Clients",
    title: true,
  },
  {
    name: "Clients",
    url: "/clients",
    icon: "icon-people",
    class: "icon-red-500",
    permission: "Clients",
  },
  {
    name: "Locations",
    url: "/locations",
    icon: "cil-building",
    class: "icon-red-600",
    permission: "Locations",
  },
  {
    name: "Analytics",
    title: true,
  },
  {
    name: "Reports",
    url: "/reports",
    icon: "icon-chart",
    class: "icon-red-700",
    permission: "Reports",
  },
  {
    name: "Route Builder",
    url: "/route-builder",
    icon: "cil-map",
    class: "icon-red-200",
    permission: "Route Builder",
  },
  {
    name: "GPS Location",
    url: "/gps",
    icon: "cil-compass",
    class: "icon-red-100",
    permission: "See GPS location",
  },
  {
    name: "Leads",
    url: "/leads",
    icon: "cil-map",
    class: "icon-red-200",
    permission: "Leads",
  },
  {
    name: "Opportunities",
    url: "/opportunity",
    icon: "cil-map",
    class: "icon-red-200",
    permission: "Opportunities",
  },
  {
    name: "Administration",
    title: true,
  },
  {
    name: "Users",
    url: "/users",
    icon: "icon-user",
    class: "icon-red-800",
    permission: "Users",
  },
  {
    name: "Documents",
    url: "/attachments",
    icon: "cil-paperclip",
    class: "icon-red-900",
    permission: "Attachments",
  },
  {
    name: "Settings",
    url: "/settings",
    icon: "icon-settings",
    class: "icon-red-400",
    permission: "Edit admin company",
  },
  {
    name: "Admin Panel",
    url: "/admin",
    icon: "icon-speedometer",
    class: "icon-red-500",
    role: "Super Admin",
  },
  {
    name: "My Account",
    url: "/account",
    icon: "icon-user",
    class: "menu-icon-users",
    permission: "Account",
  },
];
